import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@nx-vigil/core/web/auth/feature';
import { ProgressComponent } from '@nx-vigil/core/web/shared/ui';
import { NavigationShellComponent } from '@nx-vigil/core/web/shell/ui';

@Component({
  selector: 'identity-shell-feature-layout',
  imports: [CommonModule, ProgressComponent, NavigationShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if ((auth.isLoaded$ | async) === true) {
      <core-nav-shell (login)="login()" (logout)="logout()" />
    } @else {
      <core-progress />
    }
  `,
  styles: [],
})
export class IdentityShellComponent {
  protected readonly auth = inject(AuthService);

  protected login() {
    this.auth.login();
  }

  protected logout() {
    this.auth.logout();
  }
}
